
  <ngx-loading [show]="loading"></ngx-loading>
  <div style="background-color: #F4F4F4" *ngIf="info || unsubscribed">
    <perfect-scrollbar appDetermineMaxScrollHeight [itemsToWatch]="[formSubmitted, info]" >
      <script>/*
      <div
      class="clean-body"
      style="
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: 100%;
        background-color: #f2f2f2;
      "
    >
      <!--[if IE]><div class="ie-browser"><![endif]-->
      <table
        bgcolor="#f2f2f2"
        cellpadding="0"
        cellspacing="0"
        class="nl-container"
        role="presentation"
        style="
          table-layout: fixed;
          vertical-align: top;
          min-width: 320px;
          border-spacing: 0;
          border-collapse: collapse;
          mso-table-lspace: 0pt;
          mso-table-rspace: 0pt;
          background-color: #f2f2f2;
          width: 100%;
        "
        valign="top"
        width="100%"
      >
        <tbody>
          <tr style="vertical-align: top" valign="top">
            <td style="word-break: break-word; vertical-align: top" valign="top">
              <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color:#f2f2f2"><![endif]-->
              <div style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #eaf2e8;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: #eaf2e8;
                      background-image: url('data:image/png;base64,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');
                      background-position: top left;
                      background-repeat: no-repeat;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:#eaf2e8"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:#eaf2e8;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:0px; padding-bottom:0px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 0px;
                            padding-bottom: 0px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->
                          <div
                            align="center"
                            class="img-container center fixedwidth"
                            style="padding-right: 20px; padding-left: 20px"
                          >
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr style="line-height:0px"><td style="padding-right: 20px;padding-left: 20px;" align="center"><![endif]-->
                            <div style="font-size: 1px; line-height: 20px"> </div>
                            <img *ngIf="info?.clinicLogo"
                              align="center"
                              alt="Clinic Logo"
                              border="0"
                              class="center fixedwidth"
                              [src]="info.clinicLogo"
                              style="
                                text-decoration: none;
                                -ms-interpolation-mode: bicubic;
                                height: auto;
                                border: 0;
                                width: 100%;
                                max-width: 100px;
                                display: block;
                                margin: auto;
                              "
                              title="Clinic Logo"
                              width="100"
                            />
                            <div style="font-size: 1px; line-height: 20px"> </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                          </div>
                          <table
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tr style="vertical-align: top" valign="top">
                              <td
                                align="center"
                                style="
                                  word-break: break-word;
                                  vertical-align: top;
                                  padding-bottom: 0px;
                                  padding-left: 0px;
                                  padding-right: 0px;
                                  padding-top: 0px;
                                  text-align: center;
                                  width: 100%;
                                "
                                valign="top"
                                width="100%"
                              >
                              <div *ngIf="!formSubmitted; else formSubmittedResponses">
                                <h1
                                style="
                                  color: #446f27;
                                  direction: ltr;
                                  font-family: Cabin, Arial, Helvetica Neue,
                                    Helvetica, sans-serif;
                                  font-size: 46px;
                                  font-weight: normal;
                                  letter-spacing: 5px;
                                  line-height: 120%;
                                  text-align: center;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                "
                              >
                              {{unsubscribed ? 'You have been unsubscribed.' : 'Please tell us about your experience at ' + info.clinicName}}
                              </h1>
                              </div>
                              <ng-template #formSubmittedResponses>
                                <perfect-scrollbar [itemsToWatch]="[isPositiveReview, formSubmitted]" appDetermineMaxScrollHeight>
                                <h3 style="" *ngIf="isPositiveReview" [innerHTML]="info.highRatingTextContent | keepHtml"> </h3>
                                <h3 *ngIf="!isPositiveReview" [innerHTML]="info.lowRatingTextContent | keepHtml"> </h3>

                                <div class="d-flex w-100 justify-content-center" *ngIf="isPositiveReview">
                                  <a [href]="info.googleReviewUrl">

                                   <img style="width:10em" src="assets/reviews/review_us_on_google.png" />
                                  </a>
                               </div>
                              </perfect-scrollbar>
                              </ng-template>

                                <span>

                                </span>
                              </td>
                            </tr>
                          </table>

                          <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            class="divider"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              min-width: 100%;
                              -ms-text-size-adjust: 100%;
                              -webkit-text-size-adjust: 100%;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tbody>
                              <tr style="vertical-align: top" valign="top">
                                <td
                                  class="divider_inner"
                                  style="
                                    word-break: break-word;
                                    vertical-align: top;
                                    min-width: 100%;
                                    -ms-text-size-adjust: 100%;
                                    -webkit-text-size-adjust: 100%;
                                    padding-top: 10px;
                                    padding-right: 10px;
                                    padding-bottom: 10px;
                                    padding-left: 10px;
                                  "
                                  valign="top"
                                >
                                  <table
                                    align="center"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    class="divider_content"
                                    height="35"
                                    role="presentation"
                                    style="
                                      table-layout: fixed;
                                      vertical-align: top;
                                      border-spacing: 0;
                                      border-collapse: collapse;
                                      mso-table-lspace: 0pt;
                                      mso-table-rspace: 0pt;
                                      border-top: 0px solid transparent;
                                      height: 35px;
                                      width: 100%;
                                    "
                                    valign="top"
                                    width="100%"
                                  >
                                    <tbody>
                                      <tr
                                        style="vertical-align: top"
                                        valign="top"
                                      >
                                        <td
                                          height="35"
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            -ms-text-size-adjust: 100%;
                                            -webkit-text-size-adjust: 100%;
                                          "
                                          valign="top"
                                        >
                                          <span></span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
              <div *ngIf="!formSubmitted && !unsubscribed" style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #ffffff;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: #ffffff;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:#ffffff;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:0px; padding-bottom:0px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 0px;
                            padding-bottom: 0px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->

                          <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 40px; padding-left: 40px; padding-top: 15px; padding-bottom: 15px; font-family: Arial, sans-serif"><![endif]-->
                          <div
                            style="
                              color: #000000;
                              font-family: Cabin, Arial, Helvetica Neue, Helvetica,
                                sans-serif;
                              line-height: 1.5;
                              padding-top: 15px;
                              padding-right: 40px;
                              padding-bottom: 15px;
                              padding-left: 40px;
                            "
                          >
                            <div
                              class="txtTinyMce-wrapper"
                              style="
                                line-height: 1.5;
                                font-size: 12px;
                                color: #000000;
                                font-family: Cabin, Arial, Helvetica Neue,
                                  Helvetica, sans-serif;
                                mso-line-height-alt: 18px;
                              "
                            >
                              <p
                                style="
                                  margin: 0;
                                  font-size: 18px;
                                  line-height: 1.5;
                                  word-break: break-word;
                                  text-align: center;
                                  mso-line-height-alt: 27px;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                "
                              >

                              <img style="width:55vw; max-width: 450px;" [src]="info.clinicLogo">
                                <!-- <span style="font-size: 18px"
                                  >Hey there, Of all the clinics in your area, you chose ours. That makes us feel pretty special. Let us know how we did</span
                                > -->
                              </p>
                            </div>
                          </div>
                          <!--[if mso]></td></tr></table><![endif]-->
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
        <div  *ngIf="!formSubmitted && !unsubscribed">
              <div style="background-color: transparent">
                <div
                  class="block-grid five-up"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #ffffff;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: flex;
            justify-content: center;
                      width: 100%;
                      background-color: #ffffff;
                    "
                  >
          <!-- <div class="rating"> -->
            <!-- <span class="rating__result"></span>
             <i class="rating__star far fa-star"></i>
             <i class="rating__star far fa-star"></i>
             <i class="rating__star far fa-star"></i>
             <i class="rating__star far fa-star"></i>
             <i class="rating__star far fa-star"></i>
          </div> -->

          <div class="rating m-auto">
            <span class="rating__result"></span>
             <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
             <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
             <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
             <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
             <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
          </div>
          </div>

                </div>
              </div>
              <div style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #fbfbfb;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: #fbfbfb;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:#fbfbfb"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:#fbfbfb;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 5px;
                            padding-bottom: 5px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->

                          <table
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tr style="vertical-align: top" valign="top">
                              <td
                                align="center"
                                style="
                                  word-break: break-word;
                                  vertical-align: top;
                                  padding-bottom: 10px;
                                  padding-left: 30px;
                                  padding-right: 30px;
                                  padding-top: 10px;
                                  text-align: center;
                                  width: 100%;
                                "
                                valign="top"
                                width="100%"
                              >
                <textarea rows="3" maxlength="1000" style="
                text-decoration: none;
                display: inline-block;
                color: #9ab886;
                background-color: #eaf2e8;
                border-radius: 4px;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                font-size: 1em;
                border-top: 1px solid #9ab886;
                border-right: 1px solid #9ab886;
                border-bottom: 1px solid #9ab886;
                border-left: 1px solid #9ab886;
                padding-top: 10px;
                padding-bottom: 5px;
                font-family: Cabin, Arial, Helvetica Neue,
                Helvetica, sans-serif;
                text-align: center;
                mso-border-alt: none;
                word-break: keep-all;
                resize: none;
                width:100%;" id="reviewText" [(ngModel)]="reviewText" placeholder="Share details of your experience with us"></textarea>

                              </td>
                            </tr>
                          </table>
                          <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            class="divider"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              min-width: 100%;
                              -ms-text-size-adjust: 100%;
                              -webkit-text-size-adjust: 100%;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tbody>
                              <tr style="vertical-align: top" valign="top">
                                <td
                                  class="divider_inner"
                                  style="
                                    word-break: break-word;
                                    vertical-align: top;
                                    min-width: 100%;
                                    -ms-text-size-adjust: 100%;
                                    -webkit-text-size-adjust: 100%;
                                    padding-top: 20px;
                                    padding-right: 20px;
                                    padding-bottom: 20px;
                                    padding-left: 20px;
                                  "
                                  valign="top"
                                >
                                  <table
                                    align="center"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    class="divider_content"
                                    role="presentation"
                                    style="
                                      table-layout: fixed;
                                      vertical-align: top;
                                      border-spacing: 0;
                                      border-collapse: collapse;
                                      mso-table-lspace: 0pt;
                                      mso-table-rspace: 0pt;
                                      border-top: 3px solid #6bae72;
                                      width: 10%;
                                    "
                                    valign="top"
                                    width="10%"
                                  >
                                    <tbody>
                                      <tr
                                        style="vertical-align: top"
                                        valign="top"
                                      >
                                        <td
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            -ms-text-size-adjust: 100%;
                                            -webkit-text-size-adjust: 100%;
                                          "
                                          valign="top"
                                        >
                                          <span></span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            align="center"
                            class="button-container"
                            style="
                              padding-top: 10px;
                              padding-right: 10px;
                              padding-bottom: 10px;
                              padding-left: 10px;
                            "
                          >
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;"><tr><td style="padding-top: 10px; padding-right: 10px; padding-bottom: 10px; padding-left: 10px" align="center"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:31.5pt;width:96.75pt;v-text-anchor:middle;" arcsize="10%" stroke="false" fillcolor="#9ab886"><w:anchorlock/><v:textbox inset="0,0,0,0"><center style="color:#ffffff; font-family:Arial, sans-serif; font-size:16px"><![endif]-->
                            <div
                              style="
                                text-decoration: none;
                                display: inline-block;
                                color: #ffffff;
                                background-color: #9ab886;
                                border-radius: 4px;
                                -webkit-border-radius: 4px;
                                -moz-border-radius: 4px;
                                width: auto;
                                width: auto;
                                border-top: 1px solid #9ab886;
                                border-right: 1px solid #9ab886;
                                border-bottom: 1px solid #9ab886;
                                border-left: 1px solid #9ab886;
                                padding-top: 5px;
                                padding-bottom: 5px;
                                font-family: Cabin, Arial, Helvetica Neue,
                                  Helvetica, sans-serif;
                                text-align: center;
                                mso-border-alt: none;
                                word-break: keep-all;
                              "
                            >
                             <button (click)="onFormSubmit($event)"     id="submitbutton"
                                  style="
                                    font-size: 16px;
                                    line-height: 2;
                    cursor:pointer;
                                    word-break: break-word;
                    color: white;
                    background: transparent;
                    border: 0;
                                    mso-line-height-alt: 32px;
                    padding-left: 20px;
                                  padding-right: 20px;
                                  font-size: 16px;
                                  "
                                  >Submit</button>

                            </div>
                            <!--[if mso]></center></v:textbox></v:roundrect></td></tr></table><![endif]-->
                          </div>
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
              <div style="background-color: transparent">
                <div
                  class="block-grid three-up"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #fbfbfb;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: #fbfbfb;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:#fbfbfb"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="226" style="background-color:#fbfbfb;width:226px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 30px; padding-left: 30px; padding-top:30px; padding-bottom:30px;"><![endif]-->
                    <div
                      class="col num4"
                      style="
                        display: table-cell;
                        vertical-align: top;
                        max-width: 320px;
                        min-width: 224px;
                        width: 226px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 30px;
                            padding-bottom: 30px;
                            padding-right: 30px;
                            padding-left: 30px;
                          "
                        >
                          <!--<![endif]-->

                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td><td align="center" width="226" style="background-color:#fbfbfb;width:226px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 30px; padding-left: 30px; padding-top:40px; padding-bottom:30px;"><![endif]-->
                    <div
                      class="col num4"
                      style="
                        display: table-cell;
                        vertical-align: top;
                        max-width: 320px;
                        min-width: 224px;
                        width: 226px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 40px;
                            padding-bottom: 30px;
                            padding-right: 30px;
                            padding-left: 30px;
                          "
                        >
                          <!--<![endif]-->
                          <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tr style="vertical-align: top" valign="top">
                              <td
                                align="center"
                                style="
                                  word-break: break-word;
                                  vertical-align: top;
                                  padding-top: 0px;
                                  padding-bottom: 0px;
                                  padding-left: 0px;
                                  padding-right: 0px;
                                  text-align: center;
                                  font-size: 0px;
                                "
                                valign="top"
                              >

                              </td>
                            </tr>
                          </table>
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td><td align="center" width="226" style="background-color:#fbfbfb;width:226px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 30px; padding-left: 30px; padding-top:30px; padding-bottom:30px;"><![endif]-->
                    <div
                      class="col num4"
                      style="
                        display: table-cell;
                        vertical-align: top;
                        max-width: 320px;
                        min-width: 224px;
                        width: 226px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 30px;
                            padding-bottom: 30px;
                            padding-right: 30px;
                            padding-left: 30px;
                          "
                        >
                          <!--<![endif]-->
                          <!-- <table
                            cellpadding="0"
                            cellspacing="0"
                            class="social_icons"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tbody>
                              <tr style="vertical-align: top" valign="top">
                                <td
                                  style="
                                    word-break: break-word;
                                    vertical-align: top;
                                    padding-top: 10px;
                                    padding-right: 10px;
                                    padding-bottom: 10px;
                                    padding-left: 10px;
                                  "
                                  valign="top"
                                >
                                  <table
                                    align="center"
                                    cellpadding="0"
                                    cellspacing="0"
                                    class="social_table"
                                    role="presentation"
                                    style="
                                      table-layout: fixed;
                                      vertical-align: top;
                                      border-spacing: 0;
                                      border-collapse: collapse;
                                      mso-table-tspace: 0;
                                      mso-table-rspace: 0;
                                      mso-table-bspace: 0;
                                      mso-table-lspace: 0;
                                    "
                                    valign="top"
                                  >
                                    <tbody>
                                      <tr
                                        align="center"
                                        style="
                                          vertical-align: top;
                                          display: inline-block;
                                          text-align: center;
                                        "
                                        valign="top"
                                      >
                                        <td
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            padding-bottom: 0;
                                            padding-right: 2.5px;
                                            padding-left: 2.5px;
                                          "
                                          valign="top"
                                        >
                                          <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                            ><img
                                              alt="Facebook"
                                              height="32"
                                              src="images/facebook2x.png"
                                              style="
                                                text-decoration: none;
                                                -ms-interpolation-mode: bicubic;
                                                height: auto;
                                                border: 0;
                                                display: block;
                                              "
                                              title="facebook"
                                              width="32"
                                          /></a>
                                        </td>
                                        <td
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            padding-bottom: 0;
                                            padding-right: 2.5px;
                                            padding-left: 2.5px;
                                          "
                                          valign="top"
                                        >
                                          <a
                                            href="https://www.twitter.com/"
                                            target="_blank"
                                            ><img
                                              alt="Twitter"
                                              height="32"
                                              src="images/twitter2x.png"
                                              style="
                                                text-decoration: none;
                                                -ms-interpolation-mode: bicubic;
                                                height: auto;
                                                border: 0;
                                                display: block;
                                              "
                                              title="twitter"
                                              width="32"
                                          /></a>
                                        </td>
                                        <td
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            padding-bottom: 0;
                                            padding-right: 2.5px;
                                            padding-left: 2.5px;
                                          "
                                          valign="top"
                                        >
                                          <a
                                            href="https://www.linkedin.com/"
                                            target="_blank"
                                            ><img
                                              alt="Linkedin"
                                              height="32"
                                              src="images/linkedin2x.png"
                                              style="
                                                text-decoration: none;
                                                -ms-interpolation-mode: bicubic;
                                                height: auto;
                                                border: 0;
                                                display: block;
                                              "
                                              title="linkedin"
                                              width="32"
                                          /></a>
                                        </td>
                                        <td
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            padding-bottom: 0;
                                            padding-right: 2.5px;
                                            padding-left: 2.5px;
                                          "
                                          valign="top"
                                        >
                                          <a
                                            href="https://www.instagram.com/"
                                            target="_blank"
                                            ><img
                                              alt="Instagram"
                                              height="32"
                                              src="images/instagram2x.png"
                                              style="
                                                text-decoration: none;
                                                -ms-interpolation-mode: bicubic;
                                                height: auto;
                                                border: 0;
                                                display: block;
                                              "
                                              title="instagram"
                                              width="32"
                                          /></a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table> -->
                          <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top: 0px; padding-bottom: 5px; font-family: Arial, sans-serif"><![endif]-->
                          <div
                            style="
                              color: #393d47;
                              font-family: Cabin, Arial, Helvetica Neue, Helvetica,
                                sans-serif;
                              line-height: 1.5;
                              padding-top: 0px;
                              padding-right: 0px;
                              padding-bottom: 5px;
                              padding-left: 0px;
                            "
                          >
                            <div
                              class="txtTinyMce-wrapper"
                              style="
                                line-height: 1.5;
                                font-size: 12px;
                                color: #393d47;
                                font-family: Cabin, Arial, Helvetica Neue,
                                  Helvetica, sans-serif;
                                mso-line-height-alt: 18px;
                              "
                            >
                              <p
                                style="
                                  margin: 0;
                                  font-size: 14px;
                                  line-height: 1.5;
                                  word-break: break-word;
                                  text-align: center;
                                  mso-line-height-alt: 21px;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                "
                              >
                                <a
                                  href="www.emilyemr.ca"
                                  rel="noopener"
                                  style="
                                    text-decoration: underline;
                                    color: #9ab886;
                                  "
                                  target="_blank"
                                  >www.emilyemr.ca</a
                                >
                              </p>
                            </div>
                          </div>
                          <!--[if mso]></td></tr></table><![endif]-->
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
              <div style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: #fbfbfb;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: #fbfbfb;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:#fbfbfb"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:#fbfbfb;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:0px; padding-bottom:0px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 0px;
                            padding-bottom: 0px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->
                          <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 30px; padding-left: 30px; padding-top: 30px; padding-bottom: 30px; font-family: Arial, sans-serif"><![endif]-->
                          <div
                            style="
                              color: #393d47;
                              font-family: Cabin, Arial, Helvetica Neue, Helvetica,
                                sans-serif;
                              line-height: 1.5;
                              padding-top: 30px;
                              padding-right: 30px;
                              padding-bottom: 30px;
                              padding-left: 30px;
                            "
                          >
                            <div
                              class="txtTinyMce-wrapper"
                              style="
                                line-height: 1.5;
                                font-size: 12px;
                                color: #393d47;
                                font-family: Cabin, Arial, Helvetica Neue,
                                  Helvetica, sans-serif;
                                mso-line-height-alt: 18px;
                              "
                            >

                              <p
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  line-height: 1.5;
                                  word-break: break-word;
                                  text-align: center;
                                  mso-line-height-alt: 18px;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                "
                              >
                                <span style="font-size: 12px"
                                  ><span style="color: #999999"
                                    >Want to change how you receive these emails? 
                                    Click here to
                                    <a
                                      (click)="unsubscribePatient()"
                                      rel="noopener"
                                      style="
                                        text-decoration: underline;
                                        color: #9ab886;
                                      "
                                      target="_blank"
                                      >unsubscribe</a
                                    >
                                    from this list.</span
                                  ></span
                                >
                              </p>
                              <p
                                style="
                                  margin: 0;
                                  font-size: 12px;
                                  line-height: 1.5;
                                  word-break: break-word;
                                  text-align: center;
                                  mso-line-height-alt: 18px;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                "
                              >
                                <span style="font-size: 12px; color: #999999"
                                  >© 2021 All Rights Reserved.</span
                                >
                              </p>
                            </div>
                          </div>
                          <!--[if mso]></td></tr></table><![endif]-->
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
              <div style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: transparent;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: transparent;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:transparent;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 5px;
                            padding-bottom: 5px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->
                          <table
                            border="0"
                            cellpadding="0"
                            cellspacing="0"
                            class="divider"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              min-width: 100%;
                              -ms-text-size-adjust: 100%;
                              -webkit-text-size-adjust: 100%;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tbody>
                              <tr style="vertical-align: top" valign="top">
                                <td
                                  class="divider_inner"
                                  style="
                                    word-break: break-word;
                                    vertical-align: top;
                                    min-width: 100%;
                                    -ms-text-size-adjust: 100%;
                                    -webkit-text-size-adjust: 100%;
                                    padding-top: 10px;
                                    padding-right: 10px;
                                    padding-bottom: 10px;
                                    padding-left: 10px;
                                  "
                                  valign="top"
                                >
                                  <table
                                    align="center"
                                    border="0"
                                    cellpadding="0"
                                    cellspacing="0"
                                    class="divider_content"
                                    height="40"
                                    role="presentation"
                                    style="
                                      table-layout: fixed;
                                      vertical-align: top;
                                      border-spacing: 0;
                                      border-collapse: collapse;
                                      mso-table-lspace: 0pt;
                                      mso-table-rspace: 0pt;
                                      border-top: 0px solid transparent;
                                      height: 40px;
                                      width: 100%;
                                    "
                                    valign="top"
                                    width="100%"
                                  >
                                    <tbody>
                                      <tr
                                        style="vertical-align: top"
                                        valign="top"
                                      >
                                        <td
                                          height="40"
                                          style="
                                            word-break: break-word;
                                            vertical-align: top;
                                            -ms-text-size-adjust: 100%;
                                            -webkit-text-size-adjust: 100%;
                                          "
                                          valign="top"
                                        >
                                          <span></span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
              <div style="background-color: transparent">
                <div
                  class="block-grid"
                  style="
                    min-width: 320px;
                    max-width: 680px;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-word;
                    margin: 0 auto;
                    background-color: transparent;
                  "
                >
                  <div
                    style="
                      border-collapse: collapse;
                      display: table;
                      width: 100%;
                      background-color: transparent;
                    "
                  >
                    <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:680px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
                    <!--[if (mso)|(IE)]><td align="center" width="680" style="background-color:transparent;width:680px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                    <div
                      class="col num12"
                      style="
                        min-width: 320px;
                        max-width: 680px;
                        display: table-cell;
                        vertical-align: top;
                        width: 680px;
                      "
                    >
                      <div class="col_cont" style="width: 100% !important">
                        <!--[if (!mso)&(!IE)]><!-->
                        <div
                          style="
                            border-top: 0px solid transparent;
                            border-left: 0px solid transparent;
                            border-bottom: 0px solid transparent;
                            border-right: 0px solid transparent;
                            padding-top: 5px;
                            padding-bottom: 5px;
                            padding-right: 0px;
                            padding-left: 0px;
                          "
                        >
                          <!--<![endif]-->
                          <table
                            cellpadding="0"
                            cellspacing="0"
                            role="presentation"
                            style="
                              table-layout: fixed;
                              vertical-align: top;
                              border-spacing: 0;
                              border-collapse: collapse;
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                            "
                            valign="top"
                            width="100%"
                          >
                            <tr style="vertical-align: top" valign="top">
                              <td
                                align="center"
                                style="
                                  word-break: break-word;
                                  vertical-align: top;
                                  padding-top: 5px;
                                  padding-right: 0px;
                                  padding-bottom: 5px;
                                  padding-left: 0px;
                                  text-align: center;
                                "
                                valign="top"
                              >
                                <!--[if vml]><table align="left" cellpadding="0" cellspacing="0" role="presentation" style="display:inline-block;padding-left:0px;padding-right:0px;mso-table-lspace: 0pt;mso-table-rspace: 0pt;"><![endif]-->
                                <!--[if !vml]><!-->
                                <table
                                  cellpadding="0"
                                  cellspacing="0"
                                  class="icons-inner"
                                  role="presentation"
                                  style="
                                    table-layout: fixed;
                                    vertical-align: top;
                                    border-spacing: 0;
                                    border-collapse: collapse;
                                    mso-table-lspace: 0pt;
                                    mso-table-rspace: 0pt;
                                    display: inline-block;
                                    margin-right: -4px;
                                    padding-left: 0px;
                                    padding-right: 0px;
                                  "
                                  valign="top"
                                >
                                  <!--<![endif]-->
                                  <tr style="vertical-align: top" valign="top">
                                    <td
                                      align="center"
                                      style="
                                        word-break: break-word;
                                        vertical-align: top;
                                        text-align: center;
                                        padding-top: 5px;
                                        padding-bottom: 5px;
                                        padding-left: 5px;
                                        padding-right: 6px;
                                      "
                                      valign="top"
                                    >

                                    </td>
                                    <td
                                      style="
                                        word-break: break-word;
                                        font-family: Cabin, Arial, Helvetica Neue,
                                          Helvetica, sans-serif;
                                        font-size: 15px;
                                        color: #9d9d9d;
                                        vertical-align: middle;
                                        letter-spacing: undefined;
                                      "
                                      valign="middle"
                                    >

                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                          <!--[if (!mso)&(!IE)]><!-->
                        </div>
                        <!--<![endif]-->
                      </div>
                    </div>
                    <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                    <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                  </div>
                </div>
              </div>
            </div>
              <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
      <!--[if (IE)]></div><![endif]-->
    </div>
    */</script>

  <!-- NEW TEMPLATE LAYOUT -->

   <div style="background-color:#F4F4F4; min-height: 100dvh">
     
     <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
       <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation"
         style="background:#ffffff;background-color:#ffffff;width:100%;">
         <tbody>
           <tr>
             <td
               style="direction:ltr;font-size:0px;padding:20px 25px 20px 25px;padding-bottom:20px;padding-left:25px;padding-right:25px;padding-top:20px;text-align:center;">
               <div class="mj-column-per-100 mj-outlook-group-fix"
                 style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                 <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;"
                   width="100%">
                   <tbody>
                     <tr>
                       <td align="center"
                         style="font-size:0px;padding:20px 0px 0px 0px;padding-top:20px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                         <table border="0" cellpadding="0" cellspacing="0" role="presentation"
                           style="border-collapse:collapse;border-spacing:0px;">
                           <tbody>
                             <tr>
                               <td style="width:500px;">
                                <img
                                  [alt]="info?.clinicName + ' logo'"
                                  [src]="info?.clinicLogo"
                                  class="m-auto"
                                  style="border:none;
                                         max-height: fit-content;
                                         max-width: 100%;
                                         border-radius:px;
                                         display:block;
                                         outline:none;
                                         text-decoration:none;
                                         font-size:13px;"
                                  width="">
                                </td>
                             </tr>
                           </tbody>
                         </table>
                       </td>
                     </tr>
                   </tbody>
                 </table>
               </div>
             </td>
           </tr>
         </tbody>
       </table>
     </div>
     <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <div style="background-color: transparent">
        <div *ngIf="!unsubscribed else unsubTemplate">
          <div *ngIf="!formSubmitted else afterSubmissionIntro">
            <div class="w-100 d-flex">
                <span class="mx-auto my-4 section-header">Thank you for your recent visit!</span>
            </div>
            <div class="mx-4 d-flex">
              <p class="section-paragraph mx-auto w-75">
                Please take a moment to give your recent visit a rating and leave us a message. We are always looking to improve our service, and we love getting feedback from our patients to serve them better in the future.
              </p>
            </div>
            <div class="w-100 d-flex">
                <span class="mx-auto mt-4 mb-2 section-header">Rate your recent experience:</span>
            </div>
          </div>
          <ng-template #afterSubmissionIntro>
            <div class="w-100 d-flex">
                <span class="mx-auto my-4 section-header">Thank you for your review!</span>
            </div>
          </ng-template>
          <div
            class="block-grid five-up pt-0"
            style="
              min-width: 320px;
              max-width: 680px;
              overflow-wrap: break-word;
              word-wrap: break-word;
              word-break: break-word;
              margin: 0 auto;
              background-color: #ffffff;
            ">
            <div
              style="
                border-collapse: collapse;
                display: flex;
                justify-content: center;
                width: 100%;
                background-color: #ffffff;
              ">
              <div class="rating m-auto pt-0">
                <span class="rating__result"></span>
                 <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
                 <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
                 <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
                 <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
                 <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
              </div>
            </div>
          </div>
          <div *ngIf="!formSubmitted else afterSubmissionBody">
            <div class="w-100 d-flex">
                <span class="mx-auto my-4 section-header">Tell us about your experience:</span>
            </div>
          </div>
          <ng-template #afterSubmissionBody>
            <div *ngIf="isPositiveReview else negativeBody">
              <div class="mx-auto d-flex">
                <div class="section-paragraph mx-auto w-75"
                     [innerHTML]="info.highRatingTextContent">
                </div>
              </div>
              <div class="w-100 d-flex">
                  <span class="mx-auto my-4 section-header">Your Review:</span>
              </div>
            </div>
            <ng-template #negativeBody>
              <div class="section-paragraph mx-auto w-75" [innerHTML]="info.lowRatingTextContent">
              </div>
              <div class="w-75 contact-info mx-auto">Phone: {{info.phoneNumber}}</div>
              <div class="w-75 pb-3 contact-info mx-auto text-wrap text-truncate">Email: <a href="mailto:{{info.email}}">{{info.email}}</a></div>
            </ng-template>
          </ng-template>
          <div *ngIf="!formSubmitted || isPositiveReview">
            <div
              class="w-100 d-flex flex-column"
              kendoTooltip
              showOn="none">
              <textarea
                #reviewTextInput
                title="Copied to clipboard!"
                class="mx-auto mb-2 w-75 input-details"
                rows="6"
                maxlength="1000"
                id="reviewText"
                [(ngModel)]="reviewText"
                [disabled]="formSubmitted"
                placeholder="Share details of your experience with us">
              </textarea>
              <button *ngIf="formSubmitted && isPositiveReview" class="copy-btn btn em-btn em-btn-green ml-auto" (click)="copyClicked(reviewTextInput)">Copy</button>
            </div>
          </div>
          <div *ngIf="!formSubmitted else afterSubmissionFooter">
            <div class="w-100 d-flex">
              <button class="mx-auto my-4 py-3 px-5 btn em-btn em-btn-green font-weight-bold"
                      (click)="onFormSubmit($event)">SUBMIT</button>
            </div>
          </div>
          <ng-template #afterSubmissionFooter>
            <div *ngIf="isPositiveReview" class="section-paragraph mx-auto mb-5 w-75">
              Use the COPY button to easily copy and then paste your review into Google.
            </div>
            <div *ngIf="isPositiveReview" class="w-100 d-flex pb-4">
              <!-- <button class="mx-auto my-4 py-3 px-5 btn em-btn em-btn-green font-weight-bold"
                      (click)="null"><i class="fa fa-google mr-1"></i>Open Google Review</button> -->
              <div class="mx-auto d-flex w-50">
                <a class="google-review-btn w-100" [href]="info.googleReviewUrl" target="_blank">
                  <img
                  class="p-3 w-100"
                  style="cursor: pointer;"
                  src="/assets/reviews/open_google_review.png">
                </a>
              </div>
            </div>
          </ng-template>
        </div>
        <ng-template #unsubTemplate>
          <div class="d-flex">
            <div class="w-75 mx-auto mt-4 pb-5 mb-5 section-header">
              You have been unsubscribed from receiving future review requests.
            </div>
          </div>
        </ng-template>
      </div>
     </div>
     <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
     </div>
     <div class="mb-3" style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <div
         style="font-size:0px;padding:15px 25px 10px 25px;word-break:break-word;">
         <p style="border-top:solid 2px #E6E6E6;font-size:1px;margin:0px auto;width:100%;"></p>
      </div>
     <div class="d-flex justify-content-between mx-4 mt-2 pb-3" style="margin-bottom: -16px;">
      <div class="d-flex footer-third justify-content-start">
        <a [href]="info.website ? info.website : 'https://www.google.ca/search?q=' + info.clinicName" target="_blank">
          <img
            [alt]="info.clinicName + 'logo'" height="37"
            [src]="info.clinicLogo"
            style="border:none;border-radius:px;display:block;outline:none;text-decoration:none;font-size:13px;"
            width="auto">
        </a>
      </div>
      <div *ngIf="formSubmitted && !isPositiveReview"
           class="footer-third d-flex justify-content-center">
        <a [href]="info.googleReviewUrl"
           kendoTooltip
           title="Open Google review"
           target="_blank">
          <img alt="Google review link" height="37" src="/assets/reviews/google.png">
        </a>
      </div>
      <div class="d-flex footer-third flex-column align-items-end">
        <a href="https://emilyemr.com/" target="_blank"><img alt="" height="37"
           src="https://x4ysk.mjt.lu/tplimg/x4ysk/b/sj768/xl43w.png"
           style="border:none;display:block;outline:none;text-decoration:none;font-size:13px;"
           width="auto"></a>
        <span class="emily-moto">The Future of Aesthetic Software</span>
     </div>
    </div>
      <!-- <div *ngIf="!unsubscribed" class="unsub-footer d-flex">
        <span class="unsub-text mx-auto my-2" (click)="unsubscribePatient()">Click here to unsubscribe from review requests.</span>
      </div> -->
     </div>
   </div>
  </perfect-scrollbar>
</div>



<!-- <ng-template #reviewForm>

  <div class="container-fluid py-4 h-100">
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 teal-background" >

        <img class="header-logo" [src]="'https://dermmedica.emilyemr.ca/assets/svg/emily-logo-final.svg'" />
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 teal-background">

        <h1  >Thank you!</h1>
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 white-background">

        <span>Hey there, Of all the clinics in your area, you chose ours. That makes us feel pretty special. Let us know how we did</span>
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 white-background">

        <div class="rating m-auto">
          <span class="rating__result"></span>
           <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
           <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
           <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
           <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
           <i #ratingStar (click)="starClicked($event)" class="rating__star far fa-star"></i>
        </div>
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 teal-background py-2">
        <textarea rows="4"  class="w-75 h-100" style="resize: none;
        padding: 5px;
        line-height: 1.5;" placeholder="Share details of your experience with us..."></textarea>
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-10 col-md-6 teal-background pb-2">

          <button class="btn em-btn-green" (click)="onFormSubmit(null)">Submit</button>
      </div>
    </div>
    <div class="row justify-content-center text-center  ">
      <div class="col-5 col-md-3 teal-background pb-2">

     <img class="footer-logo" [src]="'https://dermmedica.emilyemr.ca/assets/svg/emily-logo-final.svg'" />
    </div>
    <div class="col-5 col-md-3 teal-background pb-2">

        <a href="www.emilyemr.ca">www.emilyemr.ca</a>
    </div>
    </div>
  </div>


</ng-template> -->
